import { library } from '@fortawesome/fontawesome-svg-core';
import { faBoxOpen } from '@fortawesome/pro-duotone-svg-icons';
import {
    faBox as faBoxReg,
    faCheckCircle as faCheckCircleReg,
    faClock as faClockReg,
    faEllipsisH as faEllipsisHReg,
    faExclamationCircle as faExclamationCircleReg,
    faQuestionCircle,
    faSpinner as faSpinnerReg,
    faTimes as faTimesReg,
    faTimesCircle as faTimesCircleReg
} from '@fortawesome/pro-regular-svg-icons';
import {
    faBarcode,
    faBox,
    faCheck,
    faCheckCircle,
    faCheckSquare,
    faChevronDoubleLeft,
    faChevronDoubleRight,
    faChevronRight,
    faCircle,
    faCircleX,
    faClock,
    faCog,
    faEnvelope,
    faExclamationCircle,
    faExclamationTriangle,
    faFileExcel,
    faFilePdf,
    faHouse,
    faInfoCircle,
    faLinkHorizontalSlash,
    faLocationPin,
    faMapMarkerCheck,
    faPen,
    faPlus,
    faPlusCircle,
    faReceipt,
    faSave,
    faShippingTimed,
    faSignIn,
    faSignOut,
    faSpinner,
    faTag,
    faTimesSquare,
    faTrash,
    faTruck,
    faUser
} from '@fortawesome/pro-solid-svg-icons';

const addIcons = (): void => {
    library.add(
        faSignIn,
        faSpinner,
        faChevronDoubleLeft,
        faInfoCircle,
        faBarcode,
        faShippingTimed,
        faClock,
        faCheckSquare,
        faCog,
        faSignOut,
        faUser,
        faMapMarkerCheck,
        faChevronDoubleRight,
        faChevronRight,
        faPlusCircle,
        faClockReg,
        faEllipsisHReg,
        faPen,
        faTrash,
        faFilePdf,
        faFileExcel,
        faExclamationTriangle,
        faSave,
        faCircle,
        faExclamationCircle,
        faSpinnerReg,
        faCheckCircle,
        faTimesReg,
        faTimesSquare,
        faHouse,
        faLinkHorizontalSlash,
        faCircleX,
        faEnvelope,
        faExclamationCircleReg,
        faLocationPin,
        faBoxReg,
        faBox,
        faCheckCircleReg,
        faPlus,
        faCheck,
        faQuestionCircle,
        faTimesCircleReg,
        faTag,
        faBoxOpen,
        faTruck,
        faReceipt
    );
};

export default addIcons;
